import { isFunction } from 'lodash';
import { useLayoutEffect } from 'react';
import { inIframe } from '../utils/location';
import { notifyParent } from '../utils/notifyIframe';

const DEFAULT_WIDTH = 720;
const IFRAME_BORDER_WIDTH = 2;

export const useResizeRoot = (widthOrCb: (() => number | null) | number | null, deps: readonly unknown[]) => {
  const getRootElement = () => document.querySelector<HTMLElement>('#root');

  useLayoutEffect(() => {
    return () => {
      if (inIframe({ ignoreForce: true })) {
        notifyParent({ type: 'survey_iframe_width', width: null });
      } else {
        const root = getRootElement();

        if (root) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const { maxWidth }: { maxWidth?: number } = window.__pollData ?? {};
          const defaultWidth = maxWidth ?? DEFAULT_WIDTH;
          root.style.maxWidth = `${defaultWidth}px`;
        }
      }
    };
  }, []);

  useLayoutEffect(() => {
    const calculatedWidth = isFunction(widthOrCb) ? widthOrCb() : widthOrCb;
    const width = !calculatedWidth || calculatedWidth < DEFAULT_WIDTH ? null : calculatedWidth;

    if (inIframe({ ignoreForce: true })) {
      notifyParent({ type: 'survey_iframe_width', width: width ? width + IFRAME_BORDER_WIDTH : null });
    } else {
      const root = getRootElement();

      if (root) {
        root.style.maxWidth = `${width ?? DEFAULT_WIDTH}px`;
      }
    }
  }, deps);
};
